<template>
    <div name="provide">
        <!-- 3자 제공 동의 -->
        <h2>[유전자검사] 개인정보 제3자 제공 동의</h2>
        솔닥 주식회사(이하 "회사“)는 업무 위탁 계약에 따라 병원 및 의원의 업무 중 일부를 대행하며, 개인정보처리자인 각 병원 및 의원의 요구에 따라 정보주체의 개인정보를 제3자에게 제공할 수 있습니다. 유전자검사 서비스 이용과 관련하여 본인의 개인정보를 제3자에게 제공하고자 하는 경우에는 ⌜개인정보보호법⌟ 등 관계 법령에 따라 본인의 동의가 필요합니다.<br><br>

        의료기관에서는 아래와 같이 수집한 귀하의 개인정보를 (주)테라젠헬스에게 제공하고자 합니다. 수집된 정보는 귀하가 동의한 내용 외 다른 목적으로 이용되지 않으며 개인정보는 언제든 열람, 정정, 삭제를 요구할 수 있습니다.<br><br>
        <table border="1" style="margin-top: 12px;">
            <thead>
                <tr>
                    <th>제공받는 자</th>
                    <th>제공 목적</th>
                    <th>제공 항목</th>
                    <th>보유 및 이용 기간</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td rowspan="3">㈜테라젠헬스</td>
                    <td>유전자검사 키트의 배송</td>
                    <td>익명화된 이름, 주소, 연락처</td>
                    <td>수집 일로부터 유전자 검사 키트 배송 완료시까지</td>
                </tr>
                <tr>
                    <td>유전자검사 서비스의 제공</td>
                    <td>생년월일, 성별</td>
                    <td>개인정보 처리방침에 따라 서비스 회원 탈퇴 및 이용계약 종료 시 또는 유전자검사 서비스 종료[1*] 시</td>
                </tr>
                <tr>
                    <td>유전자검사 서비스의 제공</td>
                    <td>흡연유무, 키, 몸무게</td>
                    <td>개인정보 처리방침에 따라 서비스 회원 탈퇴 및 이용계약 종료 시 또는 유전자검사 서비스 종료[1*] 시</td>
                </tr>                
            </tbody>
        </table><br>

        [1*] 위 보유 기간에서의 유전자검사 서비스 종료일이란 "유전자 분석서비스 동의 해지를 하였거나, 서비스 이용이 종료된 날"을 말합니다. 유전자검사 서비스 종료일 후에는 관련 민원 처리, 법령상 의무이행을 위한 목적으로만 보유 이용됩니다.<br><br>
        ※ 이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. 다만 동의 거부 시 해당 서비스를 이용하실 수 없습니다.


    </div>
</template>

<script>
export default {
    name: 'Provide'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/genetic/Provide.vue